import { faCalendarAlt, faHomeAlt,  } from "@fortawesome/free-regular-svg-icons";
import { faBroom, faCarTunnel, faChampagneGlasses, faClockRotateLeft, faDroplet, faFrownOpen, faMagic, faTruckLoading } from "@fortawesome/free-solid-svg-icons";

export const cardsData = [
    {
        title: 'Grundreinigung',
        icon: faHomeAlt,
        text: 'Regelmäßige Reinigung von Böden, Oberflächen und Gemeinschaftsbereichen.',
        boxColor: "#0554a2",
        price: "26"
    },
    {
        title: 'Tiefenreinigung',
        icon: faDroplet,
        text: 'Eine intensive, gründliche Reinigung von oben bis unten, die Ihren Raum wieder wie neu erstrahlen lässt.',
        boxColor: "#0554a2",
        price: "30"
    },
    {
        title: 'Einzugs/Auszugsreinigung',
        icon: faTruckLoading,
        text: 'Gründliche Reinigung aller Räume, Geräte, Schränke, Böden und Oberflächen für einen frischen Start.',
        boxColor: "#0554a2",
        price: "30"
    },
    {
        title: 'Büroreinigung',
        icon: faClockRotateLeft,
        text: 'Sorgfältige und detailorientierte Reinigung, die Ihren Arbeitsplatz sauber, hygienisch und produktiv hält.',
        boxColor: "#0554a2",
        price: "25"
    },
    {
        title: 'Regelmäßige Reinigung',
        icon: faBroom,
        text: 'Ideal für die regelmäßige Reinigung und Pflege Ihres Zuhauses.',
        boxColor: "#0554a2",
        price: "25"
    },
    {
        title: 'Reinigung bei Depressionen',
        icon: faFrownOpen,
        text: 'Sanfte, unvoreingenommene Reinigungsunterstützung, die Ihnen hilft, in schwierigen Zeiten wieder Komfort und Ordnung zu schaffen.',
        boxColor: "#0554a2",
        price: "45"
    },
    {
        title: 'Reinigung nach der Party',
        icon: faChampagneGlasses,
        text: 'Reinigung nach der Veranstaltung, um Ihre Räumlichkeiten nach einer Party oder einem Treffen wiederherzustellen.',
        boxColor: "#0554a2",
        price: "35"
    },
    {
        title: 'Reinigung am selben Tag',
        icon: faCalendarAlt,
        text: 'Schnelle, prioritäre Reinigung, wenn es auf die Zeit ankommt.',
        boxColor: "#0554a2",
        price: "45"
    }

]